import React, { useState, useEffect, useContext } from 'react';
import parse, { domToReact } from 'html-react-parser';
import axios from 'axios';
import { UserContext } from './hooks/UserContext';
import CourseCardPreview from './components/course/CourseCardPreview'

import './css/CardPreview.css';
import cardBackground from './css/images/card-preview-background/content-card.png'
import statusBar from './css/images/card-preview-background/header-bar.png'



const CardPreview = ({ content, selectedCourse, selectedTopic }) => {
  const [cardContent, setCardContent] = useState('');
  const [course, setCourse] = useState();
  const [currentPosition, setCurrentPosition] = useState();
  const { user } = useContext(UserContext);

  useEffect(() => {
    async function fetchCourse() {
      if (selectedCourse) {
        const data = await getCourse(selectedCourse.id);
        setCourse(data);
        const topics = await getTopics(selectedCourse.id);
        const topic = topics.find(({ name }) => name === selectedTopic.name);
        if (topic) {
          setCurrentPosition(topics.indexOf(topic) + 1);
        }
      }
    }

    fetchCourse()
  }, [selectedCourse, selectedTopic]);

  const getCourse = async (courseId) => {
    const res = await axios.get(`/api/courses/${courseId}`, {
      headers: { 'Authorization': `Bearer ${user.token}`, 'X-EDITOR': 'nanoms' }
    });

    return res.data;
  }

  const getTopics = async (courseId) => {
    const res = await axios.get(`/api/courses/${courseId}/topics`, {
      headers: { 'Authorization': `Bearer ${user.token}`, 'X-EDITOR': 'nanoms' }
    });

    return res.data.items;
  }

  useEffect(() => {
    console.log('Card preview updated');
    if (content) {
      var parser = new DOMParser();
      var htmlDoc = parser.parseFromString(content, 'text/html');
      setCardContent(content)
    } else {
      setCardContent('')
    }
  }, [content]);


  const options = {
    replace: (domNode) => {
      // Handle custom quiz tag
      if (domNode.type === "tag" && domNode.name === "quiz" && domNode.attribs) {
        return (
          <div className="quiz-container">
            <p>
              {domNode.attribs.title}
            </p>
            <p>
              {domNode.attribs.question}
            </p>
            <div class="answers">
              <img class="answer-button" alt="quiz button" />
              <div class="text">{domNode.attribs.answer1}</div>
            </div>
            <div class="answers">
              <img class="answer-button" alt="quiz button" />
              <div class="text">{domNode.attribs.answer2}</div>
            </div>
            <div class="answers">
              <img class="answer-button" alt="quiz button" />
              <div class="text">{domNode.attribs.answer3}</div>
            </div>
          </div>
        )
      }

      // Handle custom course tag
      if (domNode.type === "tag" && domNode.name === "course" && domNode.attribs) {
        return (
          <CourseCardPreview courseId={domNode.attribs.id} />
        )
      }

      // Handle custom note tag
      if (domNode.type === "tag" && domNode.name === "note" && domNode.attribs) {
        const node = domNode.attribs;
        return (
          <div className="note-container">
            <div className="note-header">
              <img className="note" src={domNode.attribs.img} />
              <p className="note">  <strong>{domNode.attribs.title}</strong> </p>
            </div>
            <div className="note-body">
              {domToReact(domNode.children, options)}
            </div>
          </div >
        )
      }

      // Handle custom appcard tag (App Store copy; the app picks by platform)
      if (domNode.type === "tag" && domNode.name === "appcard" && domNode.attribs) {
        const a = domNode.attribs;
        return (
          <div className="appcard">
            <img className="appcard-icon" src={a.img} alt="" />
            <div className="appcard-text">
              <div className="appcard-name">{a.name}</div>
              {a.tagline && <div className="appcard-tagline">{a.tagline}</div>}
              <div className="appcard-store">{a.rating ? `★ ${a.rating} · App Store` : 'App Store'}</div>
            </div>
            <span className="appcard-pill">{a.text || 'Get'}</span>
          </div>
        )
      }

      // Set image width for preview
      if (domNode.attribs && domNode.type === "tag" && domNode.name === "img") {
        domNode.attribs.class = "card";
        return domNode;
      }

      // Inline article link: derived link colour, hairline underline, and the
      // open-in-new glyph pinned to the last word (mirrors the app renderer).
      if (domNode.type === "tag" && domNode.name === "a" && domNode.attribs) {
        const children = domToReact(domNode.children, options);
        const last = Array.isArray(children) ? children[children.length - 1] : children;
        const head = Array.isArray(children) ? children.slice(0, -1) : null;
        const tail = typeof last === 'string' ? last.split(/(\s+)/) : [last];
        const lastWord = tail.pop();
        return (
          <a className="article-link" href={domNode.attribs.href} target="_blank" rel="noopener noreferrer">
            {head}{tail.join('')}
            <span className="article-link-tail">
              {lastWord}
              <svg className="article-link-glyph" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55-.45 1-1 1zM14 4c0 .55.45 1 1 1h2.59l-9.13 9.13a.996.996 0 1 0 1.41 1.41L19 6.41V9c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1z" />
              </svg>
            </span>
          </a>
        );
      }

      // Wrap button into div to align it properly to center
      if (domNode.attribs && domNode.type === "tag" && domNode.name === "button") {
        console.log({ domNode })
        return (
          <div class="button-container">
            <button>{domToReact(domNode.children, options)}</button>
          </div>
        );
      }

      // Do not show text without <p>
      // <div>Some text</div> will not be shown
      if (domNode.type === "tag" && domNode.name === "div" && domNode.children) {
        const result = domNode.children.filter(element => element.type !== 'text');
        console.log('Filtered text elements without <p>');
        domNode.children = result;
        return domNode;
      }
    }
  };

  return (
    <div className="Card-preview-wrapper">
      <img className="status-bar" src={statusBar} />
      {course && course.cover_image &&
        <img className="cover-image" src={course.cover_image} alt="course image" />
      }
      <img className="card-background" src={cardBackground} />
      <div className="card-content">
        {currentPosition > 0 &&
          <div className="progress-counter">{currentPosition} of {course.topics}</div>
        }
        <div className="Card-preview">
          {parse(cardContent, options)}
        </div>
      </div>

    </div>
  )
}

export default CardPreview;